import assetPath from '/app/xinglets/companies/companies/src/assets/svg/free-cover.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')